angular
	.module 'App.Repository'
	.factory 'QueueTaskRepository', ['BaseRepository', (BaseRepository) ->
		class QueueTaskRepository extends BaseRepository
			@resource = '/queue_tasks'
			@isRestricted = true

		return new QueueTaskRepository
	]
